<script setup lang="ts">
defineProps<{
  element?: string | Component
}>()
</script>

<template>
  <component
    :is="element || 'div'"
    class="rounded-xs bg-white flex flex-col shadow dark:bg-icsnight-800 dark:shadow-black/38"
  >
    <div v-if="$slots.top">
      <slot name="top" />
    </div>
    <div class="py-3 flex flex-col h-full md:py-4">
      <header
        v-if="$slots.header"
        class="mb-3 f-px-8-16"
      >
        <slot name="header" />
      </header>
      <div class="grow">
        <div class="f-px-8-16">
          <slot />
        </div>
        <div v-if="$slots.full">
          <slot name="full" />
        </div>
      </div>
      <footer
        v-if="$slots.footer"
        class="mt-3 f-px-8-16"
      >
        <slot name="footer" />
      </footer>
    </div>
    <div v-if="$slots.bottom">
      <slot name="bottom" />
    </div>
  </component>
</template>
